import React from "react";
import { Route, Routes } from "react-router-dom";
import FinanceDashboard from "./pages/FinanceDashboard";
import DebtorsList from "./pages/DebtorsList";
import DebtorDetail from "./pages/DebtorDetail";
import DebtorInvoicesList from "./pages/DebtorInvoicesList";
import DebtorsAgeAnalysis from "./pages/DebtorsAgeAnalysis";
import ComprehensiveAgingReport from "./pages/ComprehensiveAgingReport";
import CreditorsList from "./pages/CreditorsList";
import CreditorDetail from "./pages/CreditorDetail";
import CreditorsAgeAnalysis from "./pages/CreditorsAgeAnalysis";
import AmortisationSchedule from "./pages/AmortisationSchedule";
import CashflowForecast from "./pages/CashflowForecast";
import Statements from "./pages/Statements";
import VatStatements from "./pages/VatStatements";
import CashbookReport from "./pages/CashbookReport";
import FinanceReportsPage from "./pages/FinanceReportsPage";
import ReceiptsList from "./pages/ReceiptsList";
import FinanceImport from "./pages/FinanceImport";
import PaymentRequisitionsPage from "./pages/paymentRequisitionsPage";
import PaymentSchedulePage from "./pages/paymentSchedulePage";
import ApprovedPaymentRequisitionsPage from "./pages/approvedPaymentRequisitionsPage";
import PaymentsHistoryPage from "./pages/paymentsHistoryPage";
import PendingReviewPage from "./pages/pendingReviewPage";
import PaymentRequestsDashboardPage from "./pages/paymentRequestsDashboardPage";

const PettyCashPage = React.lazy(() => import("./pages/PettyCashPage"));
const FinanceRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<FinanceDashboard />} />
      {/* Import Routes */}
      <Route path="/import" element={<FinanceImport />} />
      {/* Debtors Routes - specific routes must come before :id */}
      <Route path="/debtors" element={<DebtorsList />} />
      <Route path="/debtors/invoices" element={<DebtorInvoicesList />} />
      <Route path="/debtors/age-analysis" element={<DebtorsAgeAnalysis />} />
      <Route
        path="/debtors/comprehensive-aging"
        element={<ComprehensiveAgingReport />}
      />
      <Route path="/debtors/amortisation" element={<AmortisationSchedule />} />
      <Route path="/debtors/statements" element={<Statements />} />
      <Route path="/debtors/vat-statements" element={<VatStatements />} />
      <Route path="/debtors/receipts" element={<ReceiptsList />} />
      <Route path="/debtors/:id/receipts" element={<DebtorDetail />} />
      <Route path="/debtors/:id" element={<DebtorDetail />} />
      {/* Creditors Routes */}
      <Route path="/creditors" element={<CreditorsList />} />
      <Route path="/creditors/:id" element={<CreditorDetail />} />
      <Route
        path="/creditors/age-analysis"
        element={<CreditorsAgeAnalysis />}
      />
      {/* Reports Routes */}
      <Route path="/reports" element={<FinanceReportsPage />} />
      <Route path="/reports/cashbook" element={<CashbookReport />} />
      <Route path="/reports/cashflow" element={<CashflowForecast />} />
      {/* Request-to-Payment Routes (now at /rtp) */}
      <Route path="/petty-cash/*" element={<PettyCashPage />} />
      {/* Payment Requisition Routes */}
      <Route
        path="/payment-requests-dashboard"
        element={<PaymentRequestsDashboardPage />}
      />
      <Route path="/pending-review" element={<PendingReviewPage />} />
      <Route path="/payment-schedule" element={<PaymentSchedulePage />} />
      <Route
        path="/approved-requisitions"
        element={<ApprovedPaymentRequisitionsPage />}
      />
      <Route
        path="/payment-requisitions"
        element={<PaymentRequisitionsPage />}
      />
      <Route path="/payments-history" element={<PaymentsHistoryPage />} />
    </Routes>
  );
};

export default FinanceRoutes;
